import moment from 'moment'

export const defaultDate = (value) => (
  value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
)

export default null
